import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=afbd4948&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=ts&"
export * from "./Paginate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbd4948",
  null
  
)

export default component.exports